export default __webpack_public_path__ + "static/media/freeLimePage.5e49d062.png";